import {Auth} from "types/auth"
import styles from "./OptInInfo.module.css"
import {ReactComponent as EmailOffIcon} from "./assets/email-off.svg"
import {ReactComponent as MobileOffIcon} from "./assets/mobile-off.svg"
import {ReactComponent as SmsOffIcon} from "./assets/sms-off.svg"
import {Tooltip} from "antd"

type Props = {
    user: Auth.UserProfile
}

export const OptInInfo = ({user}: Props) => {
    return (
        <div className={styles.optInWrap}>
            {user.emailNotifications ? null : (
                <Tooltip title="Email notifications: OFF">
                    <div className={styles.optInIconWrap}>
                        <EmailOffIcon className={styles.optInIcon} />
                    </div>
                </Tooltip>
            )}
            {user.mobileNotifications ? null : (
                <Tooltip title="Push notifications: OFF">
                    <div className={styles.optInIconWrap}>
                        <MobileOffIcon className={styles.optInIcon} />
                    </div>
                </Tooltip>
            )}
            {user.smsNotifications ? null : (
                <Tooltip title="SMS notifications: OFF">
                    <div className={styles.optInIconWrap}>
                        <SmsOffIcon className={styles.optInIcon} />
                    </div>
                </Tooltip>
            )}
        </div>
    )
}
